<ng-container>
  <div class="field-container">
    <div class="toggle-wrapper">
      <p-toggleSwitch [ngModel]="value" [disabled]="disabled" (ngModelChange)="changeToggle($event)" />
      <label *ngIf="labelText" class="label-toggle">
        {{labelText}}
      </label>
    </div>
  </div>
</ng-container>